function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "68edb368-de8c-4504-ab9c-20b2d3a10d17",
  x1: 974.2,
  y1: 792.81,
  x2: 974.2,
  y2: 205.4,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "gray",
  stopOpacity: 0.25
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "gray",
  stopOpacity: 0.12
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "gray",
  stopOpacity: 0.1
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "5cb8051f-96be-4c7d-9e37-aa3efd21256e",
  x1: 215.55,
  y1: 703.96,
  x2: 215.55,
  y2: 309.97,
  xlinkHref: "#68edb368-de8c-4504-ab9c-20b2d3a10d17"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M1091.06,692.18q-5.38,4.73-11,9.19c-.63.51-1.28,1-1.92,1.52a386.28,386.28,0,0,1-42,28.37l-2.73,1.59c-.66.4-1.31.77-2,1.14-15.26,8.81-31.09,16.92-47.11,24.6l-.17.09-1.21.57q-19.38,9.29-39.34,17.78l-.32.12q-9,3.79-18,7.38c-2.45,1-4.91,1.93-7.37,2.88-4.63,1.77-9.27,3.51-13.95,5.18l-.58.22-1,.35-1.25.46Q882.8,800.16,864,805.7l-.22.06q-13.11,3.82-26.39,7.07l-1.21.3c-13,3.14-26.21,5.84-39.5,8l-3.06.49q-14.58,2.29-29.36,3.74c-55.39,5.35-111.44,1-166.49-6.46-111.16-15.08-220.85-43.35-320.89-87.66q-28.8-12.75-56.48-27.3c-.15-.08-.28-.16-.43-.23Q203.4,695,187.28,685.56c-3.15-1.82-6.28-3.68-9.39-5.55q-5.74-3.46-11.43-7c-5-3.12-10-6.32-15-9.59l-2.34-1.56-.9-.61c-1.27-.85-2.52-1.7-3.78-2.56-47-32-88.91-70.78-108.71-119.31-22.88-56-8.24-127,48.43-160.1,19.48-11.4,42.12-17.59,65-22.7l2.34-.52c3.87-.85,7.74-1.67,11.59-2.49,13.49-2.86,27.05-5.7,40.48-8.87h0c7-1.65,13.93-3.38,20.82-5.25l2.82-.78a337.09,337.09,0,0,0,48.61-17.12l.1,0c1.69-.75,3.36-1.53,5-2.33,1.06-.5,2.12-1,3.18-1.55,17-8.46,35-20.19,48.85-34.17,1.11-1.12,2.19-2.26,3.24-3.4.81-.89,1.61-1.79,2.38-2.69,9.71-11.32,16.43-23.89,17.71-37.23h0a48,48,0,0,0-.6-13.43c-1.57-8.39-3.09-16.6-4.21-24.61-2.09-15.05-2.8-29.44.1-43.31v0c2.95-14.14,9.64-27.75,22.41-40.95q2.89-3,6.23-6A131.28,131.28,0,0,1,414.84,90q2.34-1,4.71-2c35.08-14.2,77.23-17.16,116.61-15.2A636.14,636.14,0,0,1,645.42,88c2.85.64,5.7,1.31,8.53,2a757.36,757.36,0,0,1,90,27.83c76.38,28.73,148.47,68.62,215.82,112.64.66.43,1.32.86,2,1.3q4.22,2.75,8.39,5.52,8.07,5.35,16,10.77l3.57,2.43q2.64,1.8,5.25,3.61l5.36,3.71,0,0a5.88,5.88,0,0,1,.72.51l4.56,3.16c2.64,1.84,5.26,3.69,7.89,5.55h0l5.64,4c1.17.84,2.35,1.67,3.52,2.52l6,4.38,1.34,1c.28.2.56.4.83.62l.17.11c16.26,11.93,32.13,24.3,47,37.41l1.92,1.7.2.18c1.62,1.44,3.24,2.9,4.83,4.37C1104.38,341,1121.78,360,1136,381,1201.32,478,1181.93,612.31,1091.06,692.18Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910",
  opacity: 0.1
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M1133.87,412.94c.64-1.74-4.14-11.4-4.14-11.88s-5-5.85-5-8.87-6.53-9.5-6.53-9.5-8.78-3.65-9.74-11.56-10.16-8.08-10.52-8.09c0,0,0-.72.06-1.82,0-2.46-.07-6.85-1.18-9.26a9.4,9.4,0,0,0-5.42-4.61s-1-6.17-2.88-8.07a9.09,9.09,0,0,1-2.22-8.56c.53-1.68.07-4.79-1.25-7.39-1-2.07-2.62-3.84-4.66-4.33l-.17,0c-4.58-1.11-9.71-2.81-9.71-2.81s-.52.1-1.29.21l-.64-.21a28.59,28.59,0,0,1-3.34.42,4.15,4.15,0,0,1-2.71-.89c-1.6-1.75-14.52-5.07-16.91-5.07s-9.26-3.17-9.26-3.17l-6.85-5.23c-1.92-1.46-5.48-7.4-6-8.28l-.08-.11,0,0a27.18,27.18,0,0,1-1.26-3.49c-.07-.22-.12-.44-.19-.68v0a38.15,38.15,0,0,0,3.81-4.68l0-.05c.31-.43.6-.9.89-1.35q.63-1,1.2-2.07c.16-.31.31-.63.47-.93a4,4,0,0,0,1-.17l.43-.16a5.07,5.07,0,0,0,1.1-.69l.32-.29a7.81,7.81,0,0,0,2-3.07c.11-.34.21-.69.29-1,0-.12.06-.25.09-.36s.11-.48.15-.73l.06-.4c0-.25.08-.48.12-.71s0-.28,0-.41c0-.29.08-.6.11-.9.14-1.13.26-2.24.5-3.34a.09.09,0,0,0,0-.05,25.55,25.55,0,0,1,2.36-6.08c1-1.93,2.1-3.83,3-5.82h0c.26-.57.51-1.15.73-1.73s.44-1.28.64-1.93c0-.19.09-.39.14-.59a14.05,14.05,0,0,0,.32-1.43q.08-.31.12-.63c.12-.66.2-1.32.26-2a24.54,24.54,0,0,0-1.64-11.13c-1.19-3-3-5.65-4.19-8.62-1.83-4.51-2.31-9.61-4.55-13.91-3.75-7.2-12.6-10.8-19.87-8.09-3.46,1.28-6.47,3.79-10,4.92-4.7,1.51-9.75.37-14.63-.31s-10.28-.73-14.2,2.45c-4.51,3.67-5.75,10.57-10,14.59a23,23,0,0,1-3.33,2.5c-.86.59-1.73,1.17-2.54,1.84a9.47,9.47,0,0,0-2.95,4,3.38,3.38,0,0,0-.11.34,3.11,3.11,0,0,0-.11.41c0,.15-.05.31-.07.47s0,.22,0,.33a5.77,5.77,0,0,0,0,.72h0s0,.08,0,.12c0,.26.08.53.13.8,0,.07,0,.14,0,.22s.12.45.2.66a.5.5,0,0,1,0,.13,7.22,7.22,0,0,0,.29.72c0,.11.09.24.14.36a1.38,1.38,0,0,1,.14.3,18.93,18.93,0,0,1,1.48,3.67,4.16,4.16,0,0,1-.15,2.44,3.9,3.9,0,0,1-.64,1.07,13.33,13.33,0,0,1-1.12,1.24,33.13,33.13,0,0,0-7.21,11.53c-.18.49-.35,1-.51,1.49v0l.21.06.21.05a7,7,0,0,0,1.19.25,7.25,7.25,0,0,0,.8.09,12.39,12.39,0,0,0,3.26-.26,5,5,0,0,0,.53-.12h0a.58.58,0,0,0,.16-.05l.1,0a17.32,17.32,0,0,0,2.62-.91c.2-.09.41-.17.61-.27,0,.32,0,.65,0,1s0,.36,0,.54c0,.43,0,.84,0,1.27s0,.6,0,.91a37.63,37.63,0,0,0,19.16,30.59c.57.33,1.13.64,1.71.93.05.34.1.69.14,1s.08.57.11.86l-.44-.41a2.91,2.91,0,0,0-1.19-.24,3.82,3.82,0,0,0-1.9.49,7,7,0,0,0-2.49,2.43c-2.7,4.13-7.82,6-7.82,6s-29,4.59-30.14,8.39l-13.56.8s-4.79.63-5.26,10.61v.11c0,.05,0,.08,0,.12-.07,1.19-.16,2.25-.27,3.2,0,0,0,.1,0,.14-.84,6.65-2.74,7.36-2.74,7.36s-5.59,9.82-5.11,14.89a.48.48,0,0,1,0,.12v0a6.53,6.53,0,0,1-.13,2.05,0,0,0,0,0,0,0,9,9,0,0,1-4.18,5.39l-.63,9s-5.26-.79-6.7,5.39-4,9-4,9-8.77,7.29-9.25,13.46l-5.43,3.33s-12.59-2.85-15.47-7.92c0,0-.34-.34-.88-.83l-.08-.12a.28.28,0,0,0,0,.06c-1.88-1.78-5.89-5.5-5.27-4.65a3.92,3.92,0,0,1,.26,2.56l-.94-1-2.51-2.8s-3.59-3.36-8.64-7.37l0,0q-1.73-1.38-3.65-2.82c-6.46-4.79-14.23-9.65-20-10.38-.12-.24-.6-2.05-1.73-2.05a1.9,1.9,0,0,0-1.24.61,16.64,16.64,0,0,0-.11,24.4l1.31,1.22,4.06,3.8,13.7,12.8c.17.12.33.25.5.36l.81,1,.63.81,1.09,1.39,1.57,2c-.08.21-.17.41-.24.61-.59,1.44-1.1,2.84-1.52,4.12,0,0,0,.1,0,.14-.1.32-.2.62-.29.92,0,.1-.07.21-.1.31-.1.3-.18.6-.27.87s-.1.35-.14.52-.07.21-.1.31c-.45,1.59-.73,2.81-.88,3.49l-1.06-.33,1,.45a1.36,1.36,0,0,1,0,.17l-.06.32c.31.15.64.29,1,.43l.23.1,3.92,1.73h0c.79.35,1.65.72,2.57,1.14s1.63.73,2.52,1.11h0c10.24,4.56,24.59,11.11,25.61,12.42,1.59,2.07,12.12,8.08,21.7,3s11.63-12.84,11.63-12.84,9.26-12.82,9.58-14.72c.24-1.46,4.52-3.11,6.5-3.8l.19-.06.8-.26s0,.4,0,1.09v.05c0,.35,0,.79,0,1.28,0,4.46-.06,14.16-1.46,21.21a.13.13,0,0,0,0,.06,23.06,23.06,0,0,1-1.59,5.3c-3.67,7.76-10.52,42.14-10.52,42.14l.16,0a4.64,4.64,0,0,1,1.2-.06c-.14.64-.23,1.14-.3,1.48s-.1.51-.1.51l.12,0a4.6,4.6,0,0,1,1.16-.07,2.44,2.44,0,0,1,.39.05c0,.2-.06.44-.1.72,0,0,0,.1,0,.15s0,.06,0,.1-.06.31-.08.48c-.83,5.72-3.23,20.61-3.23,20.61s-1,8.23-2.56,11.08c-.67,1.21-1.08,4.56-1.34,8,0,.5-.07,1-.11,1.52-.26,4.24-.3,8.21-.3,8.21l-.07.26L901.14,547a3.07,3.07,0,0,0,.13.29h0c.17.32.44.87.83,1.55v0l.12.26a29.78,29.78,0,0,0,5.54,7.8,14.41,14.41,0,0,0,1.68,1.43h0c0,.12-.05.25-.07.35s-.06.38-.09.56a16.19,16.19,0,0,1-1.13,4A13.38,13.38,0,0,0,907,567.6a0,0,0,0,0,0,0,20.06,20.06,0,0,0-.1,3.24l-.13.59h0c-.35,1.63-1.35,6.41-1.89,10.3-.13.89-.25,1.75-.32,2.55a12.39,12.39,0,0,0,0,2.23,18.31,18.31,0,0,1-.2,3.74c0,.36-.08.73-.13,1.1-.54,3.52-1.43,7.21-1.43,7.21l-2.87,27.55,0,.49c0,.11,0,.31,0,.57s0,.36,0,.57,0,.45-.06.72c0,.65-.1,1.42-.17,2.32q0,.48-.06,1c0,.3,0,.62-.06.95,0,.17,0,.34,0,.52s0,.52-.05.79,0,.51,0,.76,0,.47,0,.71c-.09,1.47-.19,3.06-.26,4.67,0,.26,0,.52,0,.78l0,.76c0,.51,0,1-.07,1.54,0,.34,0,.69,0,1s0,.94,0,1.4V646c0,.3,0,.6,0,.88,0,.67,0,1.32,0,1.95,0,.28,0,.57,0,.85q0,1.36,0,2.58c0,.41,0,.8,0,1.18a29.11,29.11,0,0,0,.24,3.18c.11.78.19,1.6.23,2.44,0,.39,0,.78,0,1.16a5.61,5.61,0,0,1,0,.58c0,.19,0,.4,0,.59s0,.54,0,.8c0,.42,0,.83,0,1.24,0,.17,0,.33,0,.49s0,.59,0,.88l0,.48c-.25,3.44-.72,6.23-.79,6.67,0,0,0,0,0,0v0s0,.09,0,.26,0,.15,0,.24,0,.17,0,.27,0,.11,0,.17c0,.25.06.57.09.92,0,.16,0,.32,0,.5v0c0,.18,0,.38.06.58s0,.19,0,.3c0,.36.06.73.1,1.12s.09.81.12,1.23l.06.79c0,.38.08.78.11,1.17l0,.4c0,.27.06.53.08.81l.09,1.23c0,.27.06.55.08.82s0,.28,0,.42l.13,1.62c0,.27,0,.53.05.8,0,.42.06.85.1,1.25s0,.92.07,1.34.05.84.06,1.22a16.89,16.89,0,0,1,0,3.39c-.26,1.14-1.1,4.33-1.58,7.79,0,.31-.09.62-.12.94s0,.37,0,.56l-.06.75c0,.6-.07,1.21-.07,1.8a13.87,13.87,0,0,0,.45,4,18.93,18.93,0,0,1,.5,2.64c0,.14,0,.29.05.44,0,.32.07.65.1,1s.05.68.07,1c0,.7.06,1.42.09,2.15,0,.48,0,1,0,1.45.07,4.22-.13,8.35-.19,9.41v.08c0,.12,0,.18,0,.18s1,17.75,2.07,23.44c.14.75.24,1.51.31,2.29,0,.29,0,.58.05.87a44.62,44.62,0,0,1-.68,9.84s-1.12,12.19-1.59,12.19c-.23,0-1.27,1.88-1.43,4.72v.08c-.14,3.17.83,7.53,5.25,11.84l.48.47.58-.22c4.68-1.67,9.32-3.41,13.95-5.18,2.46-.95,4.92-1.9,7.37-2.88q9.08-3.59,18-7.38l0,0a1.14,1.14,0,0,1-.57-.72c-.92-2.45.45-10,.73-11.16s2.87-25.83,2.87-25.83-1-7.75.32-11.07-1.6-16.17-1.6-16.17-1-1.58.8-3.48,1.12-18.85,1.12-18.85-.16-8.56-.16-10.78,1.92-10.3,3.66-13,.65-11.1.65-11.1v0l.1-.64c0-.24.08-.54.14-.89l.15-.85a117.52,117.52,0,0,1,3.1-13.75c2.08-6.65,4.47-18.37,4.47-18.37L973.41,583v0l.46-1.16.17-.46s6.85,12.68,6.85,24.4c0,0,1.76,14.1,1.29,17.9s1.43,21.7,1.43,21.7,2.06,25.67,2.06,26.77S988.23,693,989.83,696s-1.6,12.2-2.55,13.15.32,24.24.32,24.24-2.41,18.37-2.88,22.17c-.09.69-.23,1.73-.38,3,16-7.68,31.85-15.79,47.11-24.6.66-.37,1.31-.74,2-1.14l.11-22.73s1.12-10.61-.16-14.9-2.55-12.5-.79-14.72.16-12.51.16-12.51,0-21.71,2.39-27.09,1.6-39.44,1.6-39.44l.63-22.34s5.09-4.82,4-29.79c0-.27,0-.56,0-.85,5.56-.35,11.83-.55,12.78.23,1.52,1.22,10.08,6.76,16.71,5.38h0a8.13,8.13,0,0,0,3.06-1.27c1.44-.64,8-6.18,8-6.18l-2.54-42.73v0l-.27-4.75c.48.73.9,1.38,1.26,2,1,1.52,1.55,2.45,1.55,2.45,0-6.65,18.83-28.19,18.83-28.19s17.55-22.65,21.37-25.35,11.33-16.95,11.33-16.95a69.08,69.08,0,0,1,3.83-7.92C1139,422.29,1133.23,414.68,1133.87,412.94Zm-56.15,30.41a9.93,9.93,0,0,1-2.12,4.27c-.08-1-.16-1.93-.24-2.93,0-.08,0-.18,0-.26-1.12-13.94-2.32-30.8-1.77-32.45.45-1.32.61-4.82.66-8.18h0c.07-3.83,0-7.48,0-7.48l0,0,.18-.25c3.22,10,13.21,21.66,13.21,21.66s1.76,5.07,3.83,5.23,1.27,6.65,1.27,6.65a7.54,7.54,0,0,0-2.72,1,23.83,23.83,0,0,0-2.82,1.91l0,0C1082.62,436,1077.83,441.73,1077.72,443.35Z",
  transform: "translate(-25.44 -72.24)",
  fill: "url(#68edb368-de8c-4504-ab9c-20b2d3a10d17)"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M837,426s5.82-30.5,24.52-30.66l13.68,28.14L866,429.73S846.24,430.36,837,426Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#65617d"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M875.16,423.44,866,429.73s-13.94.44-23.9-2A27.3,27.3,0,0,1,837,426s0-.17.1-.49a.7.7,0,0,1,0-.12,69.41,69.41,0,0,1,3.54-11.2c.57-1.37,1.23-2.78,1.93-4.19,2.74-5.27,6.59-10.44,11.86-13a16.22,16.22,0,0,1,6.23-1.63l.56,0h.27l.31.62,4.62,9.51Z",
  transform: "translate(-25.44 -72.24)",
  opacity: 0.1
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M1030.48,550.15s19.65-1.88,21.38-.47,12.89,8.65,19.5,4.09,2.2-20.44,2.2-21.07-.63-23.11-.63-23.11l-11.79-15.88-14.78-27.82-30.18-3,.78,44.18-.15,22.64Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#65617d"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M1030.48,550.15s19.65-1.88,21.38-.47,12.89,8.65,19.5,4.09,2.2-20.44,2.2-21.07-.63-23.11-.63-23.11l-11.79-15.88-14.78-27.82-30.18-3,.78,44.18-.15,22.64Z",
  transform: "translate(-25.44 -72.24)",
  opacity: 0.1
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M857.55,394.52S856,413.7,844,414c0,0-3.38-2-7.94-5.45-10.5-7.85-27.15-22.95-22.55-37,6.6-20.12,38.67,17,38.67,17l2.47,2.76Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#a5636d"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M857.55,394.52S856,413.7,844,414c0,0-3.38-2-7.94-5.45l-1-1.31a15.62,15.62,0,0,0,6.55,1.77c3,.06,6.38-1,8.55-5.39a69.41,69.41,0,0,0,3.31-7.61,22.92,22.92,0,0,0,1.2-4.72Z",
  transform: "translate(-25.44 -72.24)",
  opacity: 0.1
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M852.36,429.26l-2.69-3.46-9-11.65L836,408.2a15.61,15.61,0,0,0,6.54,1.76c3,.07,6.38-1,8.55-5.39a67.51,67.51,0,0,0,3.31-7.61c1.49-4.24,1.46-6.42.93-7.16s3.34,2.85,5.2,4.62l.07.06.86.82.33.64,4.55,9.11s0,.13,0,.38C866.76,408.32,868.29,426.66,852.36,429.26Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#e7effd"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M943.62,777a4.57,4.57,0,0,0-.94-.62l-.08,0c-1.88-.79-.16-10.54.16-11.8S945.59,739,945.59,739s-.94-7.69.32-11-1.58-16-1.58-16-.94-1.57.79-3.46,1.1-18.71,1.1-18.71-.15-8.48-.15-10.69,1.88-10.21,3.61-12.89.63-11,.63-11v0l.09-.64c.05-.23.09-.53.14-.88l.15-.84c0-.2.07-.41.11-.64.09-.5.19-1,.3-1.64.06-.36.13-.74.21-1.12.23-1.2.5-2.52.79-3.87.09-.42.19-.85.29-1.27s.24-1,.37-1.52c.08-.31.15-.61.24-.92.23-.92.48-1.81.75-2.66,2-6.61,4.41-18.24,4.41-18.24l14.61-38.38.17-.46.46.89v0c1.52,3.07,6.29,13.52,6.29,23.31,0,0,1.74,14,1.26,17.76s1.42,21.54,1.42,21.54,2,25.46,2,26.56,2.52,20.76,4.09,23.74-1.57,12.11-2.52,13,.32,24.06.32,24.06-2.36,18.23-2.84,22c-.1.9-.3,2.41-.51,4.26l1.21-.57.17-.09c16-7.68,31.85-15.79,47.11-24.6l.13-24.11s1.1-10.54-.15-14.78-2.52-12.42-.8-14.63.17-12.41.17-12.41,0-21.54,2.35-26.88,1.58-39.15,1.58-39.15l.62-22.16s5.13-4.89,3.92-30.41c-.13-2.72-.33-5.67-.61-8.89-.87-9.63-1.75-18.35-2.55-25.9-.07-.65-.14-1.29-.21-1.91-.08-.84-.18-1.67-.26-2.48-.19-1.71-.37-3.35-.55-4.91-.06-.46-.11-.91-.16-1.36q-.39-3.36-.73-6.2c-.08-.74-.18-1.47-.26-2.16-.13-1-.25-2-.36-2.93,0-.22-.06-.44-.09-.66,0-.4-.09-.78-.14-1.15-.52-4.08-.83-6.31-.83-6.31h-.14l-15.81.14-34.51.33H981l-18,.17H961.9l-8.64.09h-1.47l-18,.17H932.7L925.31,516l-15.09,34.59s-.23,3.79-.76,7.49l0,.22c0,.13,0,.25-.06.36s-.06.38-.09.56a19.43,19.43,0,0,1-1.27,4.89,12.22,12.22,0,0,0-1,3.45,0,0,0,0,0,0,0,20.23,20.23,0,0,0-.23,3.83h0c0,.14,0,.21,0,.21s-1.2,5.45-1.9,10.09c-.13.89-.25,1.75-.32,2.55a16.13,16.13,0,0,0-.14,2.93,16.43,16.43,0,0,1-.11,3c0,.36-.08.73-.13,1.1-.49,3.68-1.48,7.8-1.48,7.8l-2.84,27.36a.62.62,0,0,1,0,.09c0,.11,0,.31,0,.57s0,.36,0,.57,0,.45-.06.72c0,.65-.1,1.42-.17,2.32q0,.48-.06,1c0,.3,0,.62-.06.95,0,.17,0,.34,0,.52s0,.52-.05.79,0,.51,0,.76,0,.47,0,.71c-.08,1.47-.18,3.06-.25,4.67,0,.26,0,.52,0,.78l0,.76c0,.51,0,1-.07,1.54,0,.34,0,.69,0,1s0,.94,0,1.4V646c0,.3,0,.6,0,.88,0,.67,0,1.32,0,1.95,0,.28,0,.57,0,.85q0,1.36,0,2.58c0,.41,0,.8,0,1.18a27.26,27.26,0,0,0,.24,3.34c.1.74.18,1.5.23,2.28,0,.39,0,.78,0,1.16s0,.78,0,1.17,0,.54,0,.8c0,.42,0,.83,0,1.24,0,.17,0,.33,0,.49s0,.59,0,.88l0,.48c-.25,3.44-.72,6.23-.79,6.67,0,0,0,0,0,0v0s0,.09,0,.26,0,.15,0,.24,0,.17,0,.27,0,.11,0,.17c0,.25.06.57.09.92,0,.16,0,.32,0,.5v0c0,.18,0,.38.06.58s0,.19,0,.3c0,.36.06.73.1,1.12s.08.81.12,1.23l.06.79c0,.38.08.78.11,1.17l0,.4c0,.27.06.53.08.81l.09,1.23c0,.27.06.55.08.82l0,.42.13,1.62c0,.27,0,.53.05.8,0,.42.06.85.1,1.25s0,.92.07,1.34.05.84.06,1.22a17.78,17.78,0,0,1,0,3.28,76.62,76.62,0,0,0-1.56,7.9c0,.31-.09.62-.12.94s0,.37,0,.56l-.06.75c0,.6-.07,1.21-.07,1.8a13.78,13.78,0,0,0,.45,3.77,21.18,21.18,0,0,1,.55,3.32c.08.64.13,1.32.17,2s.06,1.42.09,2.15c0,.48,0,1,0,1.45.06,4.75-.2,9.29-.2,9.29a1.09,1.09,0,0,0,0,.12v.08c.1,2,1,17.77,2,23.07a24,24,0,0,1,.35,2.84c0,.29,0,.58.05.87a45.81,45.81,0,0,1-.71,9.19S899.52,775,899.05,775c-.24,0-1.44,2.22-1.41,5.47v.08c0,3.06,1.18,7,5.19,11l1.12,1.12c4.68-1.67,9.32-3.41,13.95-5.18,2.46-.95,4.92-1.9,7.37-2.88q9.08-3.59,18-7.38Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#3f3d56"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M1026.08,304.59l-23.27,24.85s-29.86-12-26.72-16c1.22-1.58,1-6.57.32-12.08-1.1-8.71-3.46-18.74-3.46-18.74s52.19-8.49,47.78.32c-1.6,3.21-1.33,7-.33,10.44A39.58,39.58,0,0,0,1026.08,304.59Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#a5636d"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M1020.73,282.9c-1.6,3.21-2.37,3.52-1.37,7-6.82,7.32-15.5,15.33-26.29,15.33a37.24,37.24,0,0,1-16.66-3.9c-1.1-8.71-3.46-18.74-3.46-18.74S1025.14,274.09,1020.73,282.9Z",
  transform: "translate(-25.44 -72.24)",
  opacity: 0.1
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M1030.49,266.86a37.42,37.42,0,1,1-74.84,0c0-.18,0-.36,0-.54a37.42,37.42,0,0,1,74.83.54Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#a5636d"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M1035.9,513.7c-5,0-21.46.18-39.9.47h-.23l-6.09.1h-.19c-21.87.35-43.42-3.92-52.07-3.11-18.4,1.73,6.6-17,6.6-17a154,154,0,0,0,41.9,4.24l5.29-.28c16.71-.94,33.51-2.51,42.29-5.15C1034.11,497.85,1035,504.92,1035.9,513.7Z",
  transform: "translate(-25.44 -72.24)",
  opacity: 0.1
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M1035.9,512.76c-5,0-21.46.17-39.9.47h-.23l-6.09.1h-.19c-21.87.35-43.42-3.92-52.07-3.11-18.4,1.72,6.6-17,6.6-17a153.75,153.75,0,0,0,41.9,4.23l5.29-.27c16.71-.94,33.51-2.52,42.29-5.15C1034.11,496.91,1035,504,1035.9,512.76Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#5f5d7e"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M983,315l-28.93,13.52L931.76,501.1s13.2-6,20.75-2.2,30.81.32,30.81.32,17-1,19.49.94,32.08-7.86,32.08-7.86,5.34-11.95,1.25-13.83S1037.4,458,1037.4,458l-2.51-124.51-5-16-13.52-8.17-13.83,11-6.6.95Z",
  transform: "translate(-25.44 -72.24)",
  opacity: 0.1
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M983,313.08,954.08,326.6,931.76,499.22s13.2-6,20.75-2.2,30.81.31,30.81.31,17-.94,19.49.94,32.08-7.86,32.08-7.86,5.34-11.94,1.25-13.83,1.26-20.44,1.26-20.44l-2.51-124.51-5-16-13.52-8.18-13.83,11-6.6.94Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#e7effd"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M982.53,321.1s8.34,9.9,8.18,11.95-.47,6.91-.47,6.91L984,352.7s-3.46,15.88-3.46,19.18-5.5,31.91-5.5,31.91l-6.6,44-8.34,57.7,8.49,14.62,10.06-8.49L992,408.82l2.83-20.28s3-36.47,3-40.24-1.73-13.68-1.73-13.68,2.05-9.43,10.54-11.63-.63-.48-.63-.48l-4.87-3.93-4.25,1.73S985.05,316.7,982.53,321.1Z",
  transform: "translate(-25.44 -72.24)",
  opacity: 0.1
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M981.59,320.16s8.33,9.9,8.18,11.94-.48,6.92-.48,6.92L983,351.76s-3.46,15.87-3.46,19.17-5.5,31.92-5.5,31.92l-6.61,44-8.33,57.69,8.49,14.62,10.06-8.49L991,407.88l2.83-20.28s3-36.47,3-40.25-1.73-13.67-1.73-13.67,2-9.44,10.53-11.64-.62-.47-.62-.47l-4.88-3.93-4.24,1.73S984.11,315.75,981.59,320.16Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M976.09,303.65s-1.26.94-1.57,7.23-4.72,20.44-4.72,20.44,16.35-11.32,24.53-10.06Z",
  transform: "translate(-25.44 -72.24)",
  opacity: 0.1
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M976.09,301.76s-1.26.95-1.57,7.23-4.72,20.44-4.72,20.44,16.35-11.32,24.53-10.06Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#e7effd"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M1020.74,298.62,995,321.26s21.7,12.89,24.53,16,5.66-30.81,5.66-30.81Z",
  transform: "translate(-25.44 -72.24)",
  opacity: 0.1
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M1021.68,296.73,995.9,319.37s21.69,12.89,24.52,16,5.66-30.82,5.66-30.82Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#e7effd"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M977,303.65s-2.83-1.42-5.5,2.67-7.7,6-7.7,6-28.62,4.56-29.72,8.33l-13.36.78S916,322,915.56,332s-3,10.84-3,10.84-5.51,9.75-5,14.78-4.25,7.55-4.25,7.55L923,416.21s.63,21.07-3,28.77-10.38,41.82-10.38,41.82,2.83-.63,2.67,1.26-3.46,22.48-3.46,22.48-.94,8.17-2.51,11-1.73,17.61-1.73,17.61L902,549.84s6,13.36,15.1,11.47,25.62-37.57,25.62-37.57l10.53-38.51,8.18-38.05,2.36-25.78,3.77-57.07,5.5-37.73S979.23,306.32,977,303.65Z",
  transform: "translate(-25.44 -72.24)",
  opacity: 0.1
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  d: "M976.09,301.76s-2.83-1.41-5.5,2.68-7.71,6-7.71,6-28.61,4.56-29.71,8.33l-13.36.79s-4.72.63-5.19,10.53-3,10.85-3,10.85-5.5,9.75-5,14.78-4.24,7.54-4.24,7.54L922,414.32s.63,21.07-3,28.77-10.37,41.82-10.37,41.82,2.83-.63,2.67,1.26-3.46,22.48-3.46,22.48-.94,8.17-2.51,11-1.73,17.61-1.73,17.61L901.1,548s6,13.36,15.09,11.48,25.63-37.58,25.63-37.58l10.53-38.51,8.18-38,2.35-25.78,3.78-57.06,5.5-37.73S978.29,304.44,976.09,301.76Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#65617d"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M875.16,423.44,866,429.73s-13.94.44-23.9-2l-5.08-2.25-1-.45,1.05.33c5.26,1.56,9.37,1.53,12.58.45,12.91-4.34,11.48-25.65,11-30.47,0-.48-.08-.79-.1-.91a.28.28,0,0,1,0-.06l.08.12a5.72,5.72,0,0,0,.59.83,6.65,6.65,0,0,0,.58.61l0,0,4.55,9.11s0,.13,0,.38Z",
  transform: "translate(-25.44 -72.24)",
  opacity: 0.1
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  d: "M906.76,362l-4.4,1.26-.63,9s-5.19-.78-6.6,5.35-3.93,9-3.93,9-8.65,7.23-9.12,13.36l-5.35,3.3s-12.42-2.83-15.25-7.86c0,0,5.66,40.56-24.52,30.66,0,0,33.8,14.78,35.37,16.82s11.95,8,21.38,3S905.19,433,905.19,433s9.12-12.73,9.43-14.62,7.39-4.09,7.39-4.09l13.52-32.69Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#65617d"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  d: "M1017.12,317.48l4.56-20.75s2,6.76,4.09,8.33,6.76,5.19,6.76,5.19,6.76,3.15,9.11,3.15,15.1,3.3,16.67,5,7.86.47,7.86.47,5.19,1.73,9.75,2.83,6.76,8.65,5.81,11.63a9.09,9.09,0,0,0,2.2,8.49c1.89,1.89,2.83,8,2.83,8a9.22,9.22,0,0,1,5.35,4.56c1.57,3.46,1.1,11,1.1,11l-23.42,33s.31,12.73-.63,15.56,3.3,50.94,3.3,50.94l4.87,82.69s-6.44,5.5-7.86,6.13-2.83-29.24-2.83-30.34-36.31-54.4-36.31-54.4-4.88-7.86-4.88-9.59-4.56-17.6-4.56-17.6L1014,411.18Z",
  transform: "translate(-25.44 -72.24)",
  opacity: 0.1
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  d: "M1095.16,363.63c0,1.08-.06,1.8-.06,1.8l-23.41,33,0,0s.32,12.74-.62,15.57c-.55,1.64.65,18.56,1.76,32.45.79,10,1.54,18.48,1.54,18.48l2.06,35.08,2.8,47.62s-6.44,5.5-7.85,6.13-2.83-29.24-2.83-30.35S1032.21,469,1032.21,469s-4.87-7.87-4.87-9.6-4.56-17.61-4.56-17.61l-6.91-30.65,3.14-93.7,2.67-20.75s3.93,6.77,6,8.33,6.75,5.19,6.75,5.19,6.76,3.15,9.12,3.15,15.09,3.3,16.67,5,7.86.47,7.86.47,5.18,1.73,9.74,2.83,6.76,8.65,5.82,11.63a9.06,9.06,0,0,0,2.2,8.49c1.88,1.88,2.83,8,2.83,8a9.25,9.25,0,0,1,5.35,4.56C1095.09,356.82,1095.19,361.18,1095.16,363.63Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#65617d"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  d: "M925.27,784.53c-2.45,1-4.91,1.93-7.37,2.88-7.71-2.25-14.91-4.9-14.91-4.9A204.74,204.74,0,0,1,925.27,784.53Z",
  transform: "translate(-25.44 -72.24)",
  opacity: 0.1
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M999.67,700.6s18.71,4.4,19.81,7.39Z",
  transform: "translate(-25.44 -72.24)",
  opacity: 0.1
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  d: "M927.51,714.12s-9.75,2.83-.31,8.49S927.51,714.12,927.51,714.12Z",
  transform: "translate(-25.44 -72.24)",
  opacity: 0.1
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  d: "M970.74,563c1.1,0,18.24-5.66,24.21-3.14s13.37,2.51,13.37,2.51Z",
  transform: "translate(-25.44 -72.24)",
  opacity: 0.1
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M973,581l-.17,1.56L958.17,620.9s-2.36,11.63-4.41,18.23a119.52,119.52,0,0,0-3.06,13.65l13-80.46Z",
  transform: "translate(-25.44 -72.24)",
  opacity: 0.1
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  d: "M995.77,513.23l-6.09.1h-.19l-3.57-15.85c1.75-.08,3.52-.17,5.29-.28Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#3f3d56"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  d: "M1069.94,494l-3.91,3.23L1053,508s-35.37,18.87-45.11.94c-8.59-15.79,31.51-27.06,41.17-29.52,1.31-.33,2.06-.5,2.06-.5Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#a5636d"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  d: "M918.87,339.49s6.91,3.15,8.48,7.55S918.87,339.49,918.87,339.49Z",
  transform: "translate(-25.44 -72.24)",
  opacity: 0.1
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  d: "M897.48,386.66s-10.06,12.26-6,17S897.48,386.66,897.48,386.66Z",
  transform: "translate(-25.44 -72.24)",
  opacity: 0.1
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  d: "M1077.33,346.41s-9.43.94-9.75,9.12Z",
  transform: "translate(-25.44 -72.24)",
  opacity: 0.1
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  d: "M989.92,475.32c1-.94,22.64-33,27.67-30.18Z",
  transform: "translate(-25.44 -72.24)",
  opacity: 0.1
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  d: "M1030.49,266.86a37.29,37.29,0,0,1-4.43,17.66l-.28,0c-2.37-.5-3.6-3.26-5.41-5a7.37,7.37,0,0,0-8.49-1.19,8.61,8.61,0,0,0-4.17,8.07c-1.2-5-.82-10.39-2-15.43s-4.69-10.15-9.51-10.24c-2.08,0-4.5.77-6-.79-.91-.94-1.09-2.42-1.77-3.56-3.45-5.57-13.93-2.75-18.21.11s-9.25,7.42-14.57,9.87a37.42,37.42,0,0,1,74.83.54Z",
  transform: "translate(-25.44 -72.24)",
  opacity: 0.1
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  d: "M988.44,255.4c.68,1.14.86,2.62,1.77,3.56,1.5,1.55,3.92.75,6,.79,4.82.08,8.34,5.19,9.51,10.23s.79,10.4,2,15.43a8.61,8.61,0,0,1,4.17-8.06,7.35,7.35,0,0,1,8.48,1.19c1.81,1.72,3,4.48,5.42,5s4.66-1.78,5.52-4.28.79-5.24,1.35-7.83c1.07-4.91,4.27-8.93,6-13.59a24.6,24.6,0,0,0-.16-17.56c-1.18-3-2.93-5.61-4.13-8.56-1.8-4.48-2.28-9.53-4.48-13.8-3.7-7.15-12.42-10.72-19.58-8-3.42,1.29-6.39,3.78-9.86,4.89-4.64,1.49-9.61.37-14.42-.3s-10.13-.73-14,2.43c-4.45,3.64-5.67,10.48-9.85,14.48-1.76,1.68-3.94,2.75-5.79,4.3s-3.45,3.86-3.24,6.38c.28,3.26,3.47,6.22,2.29,9.23a7.29,7.29,0,0,1-1.75,2.3,33,33,0,0,0-7.61,12.95c8.42,2.63,17.52-6.65,24.11-11C974.52,252.65,985,249.82,988.44,255.4Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#4c3e42"
});

var _ref45 = /*#__PURE__*/React.createElement("path", {
  d: "M1069.94,494l-3.91,3.23c-3.45-5.75-17.62-17.23-17.62-17.23l.61-.59c1.31-.33,2.06-.5,2.06-.5Z",
  transform: "translate(-25.44 -72.24)",
  opacity: 0.1
});

var _ref46 = /*#__PURE__*/React.createElement("path", {
  d: "M1073.72,488.21s-1.41,3.5-2.86,6.53-3,5.77-3.12,3.54c-.16-4.41-18.39-19.19-18.39-19.19l2.47-2.4,2.87-2.79Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#e7effd"
});

var _ref47 = /*#__PURE__*/React.createElement("path", {
  d: "M1074.35,464.94l2.06,35.08c-4.88-7.59-18.29-27.06-26.91-26.43l20.91-24a26.9,26.9,0,0,0,2.4-3.08C1073.6,456.49,1074.35,464.94,1074.35,464.94Z",
  transform: "translate(-25.44 -72.24)",
  opacity: 0.1
});

var _ref48 = /*#__PURE__*/React.createElement("path", {
  d: "M1073.72,488.21s-1.41,3.5-2.86,6.53c-5.48-7.52-13-16.39-19-18.05l2.87-2.79Z",
  transform: "translate(-25.44 -72.24)",
  opacity: 0.1
});

var _ref49 = /*#__PURE__*/React.createElement("path", {
  d: "M1089.44,361l5.66,4.4s9.43.16,10.37,8,9.59,11.48,9.59,11.48,6.45,6.44,6.45,9.43,4.87,8.33,4.87,8.8,4.72,10.06,4.09,11.79,5,9.28,3.3,12.11a69.39,69.39,0,0,0-3.77,7.86s-7.39,14.15-11.17,16.82-21.06,25.15-21.06,25.15-18.55,21.38-18.55,28c0,0-18.08-30.19-28.77-29.4l20.91-24.05s3.61-3.93,3.77-6.29,10.06-13.21,14.78-13.68c0,0,.78-6.45-1.26-6.6s-3.77-5.19-3.77-5.19-13.84-16.35-14-26.73S1089.44,361,1089.44,361Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#65617d"
});

var _ref50 = /*#__PURE__*/React.createElement("path", {
  d: "M1097.77,376s-13.21,9.74-10.38,12.89S1097.77,376,1097.77,376Z",
  transform: "translate(-25.44 -72.24)",
  opacity: 0.1
});

var _ref51 = /*#__PURE__*/React.createElement("path", {
  d: "M1098.4,416.21s24.52-7.86,27,0Z",
  transform: "translate(-25.44 -72.24)",
  opacity: 0.1
});

var _ref52 = /*#__PURE__*/React.createElement("path", {
  d: "M925.39,374.08s0,35.84-3.07,39.38S925.39,374.08,925.39,374.08Z",
  transform: "translate(-25.44 -72.24)",
  opacity: 0.1
});

var _ref53 = /*#__PURE__*/React.createElement("path", {
  d: "M1067.11,385.63l4.56,12.81S1073.48,385.87,1067.11,385.63Z",
  transform: "translate(-25.44 -72.24)",
  opacity: 0.1
});

var _ref54 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.1
}, /*#__PURE__*/React.createElement("path", {
  d: "M956,248.22c1.15-2.95-1.86-5.84-2.26-9a6,6,0,0,0-.5,2.84c.2,2.39,2,4.61,2.43,6.82A4,4,0,0,0,956,248.22Z",
  transform: "translate(-25.44 -72.24)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1008.13,282.08c-1.13-5-.8-10.21-1.94-15.16s-4.69-10.16-9.51-10.24c-2.08,0-4.5.76-6-.79-.91-.94-1.09-2.42-1.77-3.56-3.44-5.57-13.92-2.75-18.21.11-6.43,4.27-15.26,13.21-23.51,11.19-.39.95-.76,1.91-1.07,2.9,8.42,2.63,17.52-6.65,24.11-11,4.29-2.85,14.76-5.68,18.21-.1.68,1.14.86,2.62,1.77,3.56,1.5,1.55,3.92.75,6,.79,4.82.08,8.34,5.19,9.51,10.23s.79,10.4,2,15.43A8.54,8.54,0,0,1,1008.13,282.08Z",
  transform: "translate(-25.44 -72.24)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1031.77,276.18c-.86,2.5-3.1,4.79-5.52,4.28s-3.6-3.26-5.41-5a7.38,7.38,0,0,0-8.49-1.18,8.55,8.55,0,0,0-4.17,7.61,8.21,8.21,0,0,1,3.7-4.55,7.35,7.35,0,0,1,8.48,1.19c1.81,1.72,3,4.48,5.42,5s4.66-1.78,5.52-4.28a22,22,0,0,0,.86-4.52A14.06,14.06,0,0,1,1031.77,276.18Z",
  transform: "translate(-25.44 -72.24)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1039.16,254.77c-1.77,4.66-5,8.68-6,13.58-.22,1-.34,2-.46,3,1.07-4.88,4.26-8.89,6-13.54a23.72,23.72,0,0,0,1.45-6.52A22.78,22.78,0,0,1,1039.16,254.77Z",
  transform: "translate(-25.44 -72.24)"
}));

var _ref55 = /*#__PURE__*/React.createElement("circle", {
  cx: 786.53,
  cy: 295.97,
  r: 0.39,
  fill: "#e6e8ec"
});

var _ref56 = /*#__PURE__*/React.createElement("path", {
  d: "M497.7,587.63s11-7.89,22.43-3c0,0-3.2,6.78-17.4,6.69Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
});

var _ref57 = /*#__PURE__*/React.createElement("path", {
  d: "M496.33,588.09s-2.94,13.23,6,21.81c0,0,5-5.6-.67-18.63Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
});

var _ref58 = /*#__PURE__*/React.createElement("path", {
  d: "M481.75,576.05s.41-11.17,25.7-8.44c0,0,.4,7.19-8.3,10.93S486.3,579.57,481.75,576.05Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
});

var _ref59 = /*#__PURE__*/React.createElement("path", {
  d: "M480.2,576s-10.5,3.82-.12,27.05c0,0,7-1.84,7.84-11.27S484.94,579.28,480.2,576Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
});

var _ref60 = /*#__PURE__*/React.createElement("path", {
  d: "M465.36,560.78S463.22,542.51,489,543.4c0,0,2.46,16.52-18.93,21.61Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
});

var _ref61 = /*#__PURE__*/React.createElement("path", {
  d: "M447.58,540.74s2.73-20.91,28.66-15.7c0,0,.78,18-24.28,20.49Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
});

var _ref62 = /*#__PURE__*/React.createElement("path", {
  d: "M434.35,519.82s5.12-20.5,30.81-15.37c0,0-5.36,18.42-29,19Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
});

var _ref63 = /*#__PURE__*/React.createElement("path", {
  d: "M421.76,499.38s5-21.22,29.77-15.85c0,0-7.44,20.26-28,19.37Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
});

var _ref64 = /*#__PURE__*/React.createElement("path", {
  d: "M413.39,479.83S416.84,454,440,458.78c0,0-5.76,23.62-24.76,24.72Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
});

var _ref65 = /*#__PURE__*/React.createElement("path", {
  d: "M405.35,456.12s4.33-26.09,27.78-19.45c0,0-8.15,24.81-26,23Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
});

var _ref66 = /*#__PURE__*/React.createElement("path", {
  d: "M400.08,434s7.46-26.21,25.42-26.2c0,0-7.6,27.67-23.72,31.33Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
});

var _ref67 = /*#__PURE__*/React.createElement("path", {
  d: "M396.45,412.31s8-31.51,22.68-29.67c0,0-5.45,24.06-22,34.5Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
});

var _ref68 = /*#__PURE__*/React.createElement("path", {
  d: "M393.86,386.36s7.62-26.3,22-27.88c0,0-4.89,25.77-21.41,34.61Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
});

var _ref69 = /*#__PURE__*/React.createElement("path", {
  d: "M391.19,362.21s9.75-26.4,19.25-27.35c0,0-3.69,25.77-18.14,31.58Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
});

var _ref70 = /*#__PURE__*/React.createElement("path", {
  d: "M389.13,339.71s5.53-28.49,14.94-31.19c0,0-.41,23.14-13.9,33.26Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
});

var _ref71 = /*#__PURE__*/React.createElement("path", {
  d: "M384.42,310.34s6.09-22.77,13.66-26.49c0,0-.51,26.58-11.66,31.92Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
});

var _ref72 = /*#__PURE__*/React.createElement("path", {
  d: "M380.71,291.07l-2.92-39.63S393.3,280.84,382,298Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
});

var _ref73 = /*#__PURE__*/React.createElement("path", {
  d: "M368.08,252.06s-11.46-28.57-14-30.09c0,0,21,18,20,42.27Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
});

var _ref74 = /*#__PURE__*/React.createElement("path", {
  d: "M464.65,560.67s-18.32-1.68-16.79,24.06c0,0,16.58,2,21.14-19.46Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
});

var _ref75 = /*#__PURE__*/React.createElement("path", {
  d: "M446.69,540.08s-21.07.74-18.34,27c0,0,17.8,2.48,22.69-22.22Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
});

var _ref76 = /*#__PURE__*/React.createElement("path", {
  d: "M434.21,521.54s-19.47-8.24-30.82,15.37c0,0,17.95,6.8,32.65-11.7Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
});

var _ref77 = /*#__PURE__*/React.createElement("path", {
  d: "M421.34,499.59s-19.95-8.79-30.58,14.26c0,0,20.67,6.24,32.33-10.74Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
});

var _ref78 = /*#__PURE__*/React.createElement("path", {
  d: "M413.66,480.38s-19.53-17.28-33.87,1.5c0,0,19.82,14.07,34.89,2.47Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
});

var _ref79 = /*#__PURE__*/React.createElement("path", {
  d: "M406.4,455.47s-19.67-17.69-33.85,2.14c0,0,21.86,14.29,34.67,1.69Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
});

var _ref80 = /*#__PURE__*/React.createElement("path", {
  d: "M402,433.17s-15.49-22.42-32.48-16.64c0,0,16.08,23.76,32.52,22Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
});

var _ref81 = /*#__PURE__*/React.createElement("path", {
  d: "M396.87,412.15s-15.83-28.4-29.55-22.84c0,0,11.46,21.85,30.12,27.69Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
});

var _ref82 = /*#__PURE__*/React.createElement("path", {
  d: "M394.81,384.84s-16-22.21-30.06-18.88c0,0,13.24,22.63,31.78,25.42Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
});

var _ref83 = /*#__PURE__*/React.createElement("path", {
  d: "M392.77,361.64s-12.7-25.12-22.25-25c0,0,6.61,25.18,21.62,29.31Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
});

var _ref84 = /*#__PURE__*/React.createElement("path", {
  d: "M389.58,339.13s-14-25.4-23.82-25.07c0,0,7.52,21.89,23.47,27.37Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
});

var _ref85 = /*#__PURE__*/React.createElement("path", {
  d: "M386.57,311.84S376,290.78,367.84,288.67c0,0,5.87,25.93,17.88,28.9Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
});

var _ref86 = /*#__PURE__*/React.createElement("path", {
  d: "M379.52,290.36,356.46,258s6.84,32.52,26.48,38.55Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
});

var _ref87 = /*#__PURE__*/React.createElement("path", {
  d: "M363.19,254.92s-26-16.51-27-19.29c0,0,13.86,24,37.9,27.39Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
});

var _ref88 = /*#__PURE__*/React.createElement("path", {
  d: "M361.37,247.12s-30.14-26.83-37.56-26.52c0,0,24,.18,38.2,25Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
});

var _ref89 = /*#__PURE__*/React.createElement("path", {
  d: "M386.45,316l-1.06.18c-7.1-42.55-16-67.52-25.15-70.3l.31-1C370.22,247.8,379.17,272.41,386.45,316Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#444053"
});

var _ref90 = /*#__PURE__*/React.createElement("path", {
  d: "M398.39,417.94l-1.59.2c-.49-4-.9-8.06-1.24-12.12-2.88-35.34-6.49-67.75-10.53-92l.88-1.18c4,24.29,8.37,57.66,11.26,93C397.49,409.93,397.91,414,398.39,417.94Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#444053"
});

var _ref91 = /*#__PURE__*/React.createElement("path", {
  d: "M528.34,606.85c-.29-.12-28.94-11.61-59.33-40.5a232.38,232.38,0,0,1-44.45-58.12c-14.57-27-24.11-60.52-28.13-93.28l1.7.72c9,73.52,44.54,122.66,72.29,149.06,30.09,28.63,58.42,40,58.7,40.13Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#444053"
});

var _ref92 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.7
}, /*#__PURE__*/React.createElement("path", {
  d: "M548.25,574.23s12.86-4.25,22.3,3.79c0,0-5.07,5.53-18.6,1.21Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
}), /*#__PURE__*/React.createElement("path", {
  d: "M546.8,574.25s-6.74,11.76-.74,22.62c0,0,6.43-3.87,4.9-18Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
}), /*#__PURE__*/React.createElement("path", {
  d: "M536.46,558.43s3.72-10.55,27-.41c0,0-1.76,7-11.18,8S539.76,563.14,536.46,558.43Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
}), /*#__PURE__*/React.createElement("path", {
  d: "M535,558s-11.17.53-8.16,25.79c0,0,7.18.32,10.83-8.42S538.55,562.46,535,558Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
}), /*#__PURE__*/React.createElement("path", {
  d: "M525.35,539s3.4-18.08,27.74-9.56c0,0-2.57,16.5-24.5,15Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
}), /*#__PURE__*/React.createElement("path", {
  d: "M514.34,514.55s8.83-19.15,32-6.46c0,0-4.59,17.37-29.27,12.33Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
}), /*#__PURE__*/React.createElement("path", {
  d: "M507.93,490.64s11-18.05,34-5.51c0,0-10.6,16-33.34,9.56Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
}), /*#__PURE__*/React.createElement("path", {
  d: "M502,467.38s11.06-18.78,33.15-6.28c0,0-13.13,17.13-32.52,10.16Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
}), /*#__PURE__*/React.createElement("path", {
  d: "M499.83,446.22s11-23.65,31.64-12.18c0,0-12.53,20.83-31,16.23Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
}), /*#__PURE__*/React.createElement("path", {
  d: "M499.2,421.2s11.9-23.62,32.31-10.3c0,0-15.17,21.26-31.68,14.17Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
}), /*#__PURE__*/React.createElement("path", {
  d: "M500.76,398.49s14.92-22.8,32.06-17.45c0,0-15.49,24.16-32,22.86Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
}), /*#__PURE__*/React.createElement("path", {
  d: "M503.74,376.72s17-27.71,30.48-21.57c0,0-12.37,21.34-31.25,26.39Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
}), /*#__PURE__*/React.createElement("path", {
  d: "M509,351.17s15.1-22.83,29.28-20.07c0,0-12.33,23.15-30.74,26.68Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
}), /*#__PURE__*/React.createElement("path", {
  d: "M513.62,327.33s17.17-22.31,26.52-20.39c0,0-11.19,23.5-26.71,24.76Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
}), /*#__PURE__*/React.createElement("path", {
  d: "M518.35,305.23s13.75-25.55,23.55-25.33c0,0-7.28,22-23.18,27.62Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
}), /*#__PURE__*/React.createElement("path", {
  d: "M522.6,275.79s12.58-19.92,20.92-21.23c0,0-8.4,25.23-20.63,27Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
}), /*#__PURE__*/React.createElement("path", {
  d: "M524.78,256.28l9-38.69s6.07,32.67-9.8,45.73Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
}), /*#__PURE__*/React.createElement("path", {
  d: "M524.33,215.29s-2.44-30.69-4.43-32.9c0,0,14.73,23.46,6.5,46.3Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
}), /*#__PURE__*/React.createElement("path", {
  d: "M524.71,538.66s-17-7.07-23.18,18c0,0,15.21,6.89,26-12.29Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
}), /*#__PURE__*/React.createElement("path", {
  d: "M513.69,513.65s-20.33-5.56-25.55,20.36c0,0,16.25,7.67,28.28-14.46Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
}), /*#__PURE__*/React.createElement("path", {
  d: "M507.29,492.24s-16.13-13.66-34,5.51c0,0,15.11,11.83,34.65-1.46Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
}), /*#__PURE__*/React.createElement("path", {
  d: "M501.53,467.46S485.11,453.13,468.1,472c0,0,17.87,12.1,34.06-.65Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
}), /*#__PURE__*/React.createElement("path", {
  d: "M499.92,446.83s-13.51-22.31-32.78-8.65c0,0,14.73,19.34,32.57,12.74Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
}), /*#__PURE__*/React.createElement("path", {
  d: "M500.4,420.88s-13.52-22.73-33-8c0,0,16.62,20.15,32.6,11.93Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
}), /*#__PURE__*/React.createElement("path", {
  d: "M502.82,398.28s-8.11-26-26.06-25.55c0,0,8.29,27.48,24.5,30.73Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
}), /*#__PURE__*/React.createElement("path", {
  d: "M504.19,376.69s-6.67-31.82-21.42-30.59c0,0,4.44,24.27,20.52,35.39Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
}), /*#__PURE__*/React.createElement("path", {
  d: "M510.35,350s-8.67-26-23.09-27c0,0,5.92,25.56,22.78,33.73Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
}), /*#__PURE__*/React.createElement("path", {
  d: "M515.3,327.25s-4.65-27.76-13.81-30.47c0,0-1.18,26,11.93,34.42Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
}), /*#__PURE__*/React.createElement("path", {
  d: "M519,304.81s-5.83-28.42-15.28-31c0,0,.66,23.13,14.27,33.11Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
}), /*#__PURE__*/React.createElement("path", {
  d: "M524.2,277.87s-3.83-23.25-11-27.71c0,0-2.11,26.51,8.47,32.92Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
}), /*#__PURE__*/React.createElement("path", {
  d: "M523.86,255.26l-12.39-37.75s-3.15,33.09,13.81,44.69Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
}), /*#__PURE__*/React.createElement("path", {
  d: "M518.81,216.57s-19.91-23.5-20-26.46c0,0,6.09,27,28,37.42Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
}), /*#__PURE__*/React.createElement("path", {
  d: "M519.39,208.58s-20.79-34.59-28-36.5c0,0,22.88,7.32,29,35.24Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
}), /*#__PURE__*/React.createElement("path", {
  d: "M522.84,281.8l-1.06-.15c5.88-42.73,4.78-69.23-3.1-74.6l.61-.88C527.64,211.86,528.87,238,522.84,281.8Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#444053"
}), /*#__PURE__*/React.createElement("path", {
  d: "M503.92,382.68l-1.58-.29c.72-3.95,1.53-8,2.43-11.94,7.76-34.59,14-66.61,17.31-91l1.19-.86c-3.36,24.39-9.16,57.54-16.94,92.17C505.45,374.76,504.63,378.75,503.92,382.68Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#444053"
}), /*#__PURE__*/React.createElement("path", {
  d: "M571.78,601.69c-.24-.19-24.18-19.7-44.59-56.31A232.08,232.08,0,0,1,502,476.66c-5.88-30.12-5-65,.89-97.42l1.41,1.19c-13.25,72.88,6,130.36,24.67,163.82,20.21,36.28,43.87,55.58,44.11,55.77Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#444053"
}));

var _ref93 = /*#__PURE__*/React.createElement("path", {
  d: "M332.8,509.57a38,38,0,0,1-7.29,2.18A73.27,73.27,0,0,1,312.28,513c.13,1.17.23,2.26.33,3.25.24,2.72.38,4.59.38,4.59l-4.69-.32-38.68-2.64L247,514.53a42.2,42.2,0,0,0,3.55,4.17,18.71,18.71,0,0,0,4.52,3.51s20.41,16.53,23.94,16.68c.5,0,.66.5.58,1.29,8.59,0,35.3,1.25,27.89,16.12a11.85,11.85,0,0,1-6.07,5.91c-8.57,3.63-21.5-2.9-28.16-6.91-.65,1.27-1.27,2.45-1.82,3.46-1.13,2.13-1.92,3.54-1.92,3.54l-.67-.48-34.32-24.44L227,531a26.24,26.24,0,0,1-6.51-1.13h0l-1-.32a1.92,1.92,0,0,0-.11.27,14,14,0,0,0-.61,2.4c0,.12,0,.24,0,.36a28.11,28.11,0,0,0-.28,2.81c0,.64-.05,1.32-.05,2-.06,13.62,5.4,35.51,5.4,35.51s14.15,36.09,9.13,44.42v0a3.75,3.75,0,0,1-1,1.08c-1.77,1.28-2.83,3.56-3.38,6.27C226.72,633.51,230,647,230,647s-.3.5-.81,1.28a38.67,38.67,0,0,1-3.72,5c-.21.24-.43.49-.66.72a17.41,17.41,0,0,1-2,1.8c.13.39.27.79.41,1.22s.32,1.1.46,1.7a24.38,24.38,0,0,1-1.25,14.71A40.53,40.53,0,0,0,219.91,684v0a80.86,80.86,0,0,0,.51,19.9c-.15-.08-.28-.16-.43-.23Q203.4,695,187.28,685.56c-3.15-1.82-6.28-3.68-9.39-5.55q-5.74-3.46-11.43-7c-5-3.12-10-6.32-15-9.59l-2.34-1.56-.9-.61c-1.27-.85-2.52-1.7-3.78-2.56a192.07,192.07,0,0,1-14.14-21c-.71-1.27-1.35-2.48-1.88-3.59l0-.06-.34-.73-1.41-.5h0c-2.65-.93-4.33-1.58-4.33-1.58a.1.1,0,0,1,0,0h0a49.06,49.06,0,0,0,1.74-13.7c-.08-9-2.57-21-12.83-30.62C96.09,572.58,94,558.43,93.78,553c0-.38,0-.72,0-1a12.53,12.53,0,0,1,.06-1.37L95,549.52c-2.94-.59-5.7-.86-5.7-.86s10.06-36.4,27-48.55c8.4-6,15.39-16,20.33-24.58a372.54,372.54,0,0,1,30.28-44.39l3.05-3.85.89-1.13.19-.23.24-.32q-.62-.94-1.26-1.86l-.28-.41c-1.33-2-2.47-4-2.29-6.39,0,0,0-.05,0-.07,0-.17,0-.33,0-.51a7.68,7.68,0,0,1,.22-1.18,1.13,1.13,0,0,0,.12.18c1.43-4.16,6.94-6,11-8.3,9.57-5.38,13.65-17.15,15.7-28.1,1.59-8.52,2.91-18.07,9.51-23.54,4.26-3.52,10-4.68,14.31-8.17a26.82,26.82,0,0,0,6.08-7.81c1-1.7,1.86-3.46,2.79-5.16,4.26-7.7,9.86-14.86,17.27-19.47s16.81-6.4,24.93-3.3c3.13,1.19,6,3,9,4.33a35.06,35.06,0,0,0,5.72,1.78c6.11,1.43,12.54,1.8,18.28,4.35,9.33,4.14,15.4,13.3,20.94,22,2.87,4.5,7.38,11.08,9.94,17.7,0-.24,0-.46,0-.69a25.39,25.39,0,0,1,2,9.2,14,14,0,0,1-.43,4c-.92,3.4-3.27,5.55-6.22,7.13l-.47.23a20,20,0,0,1-1.94.87c-.1.55-.21,1.11-.33,1.65-.05.23-.11.47-.17.7-.13.56-.28,1.11-.44,1.66a38.48,38.48,0,0,1-12,18.34,40.33,40.33,0,0,1-13.42,7.6c-.35.12-.72.21-1.07.32a8.62,8.62,0,0,1-1.26,2.33,6.73,6.73,0,0,1-1.36,1.31,8.25,8.25,0,0,1-1,.58,1.34,1.34,0,0,1-.27.13c-3.6,1.62-8.53.35-12-2.07-.18-.12-.35-.26-.52-.39,0,.57-.09,1.17-.19,1.79s-.17,1-.28,1.52-.15.77-.22,1.14-.12.62-.18.91l-.12.51a78.56,78.56,0,0,1-11.14,27.1,38.64,38.64,0,0,1-2.53,3.41l-2.48,3.78,0,.51c.47,8.7-2.39,16.81-6.43,23.79a69.36,69.36,0,0,1-4.45,6.69l.56.33c5.6,3.19,16.64,8.86,23.62,8.38,0,0,26.4,3.41,29.46,1.7.42-.24.83.09,1.21.8,4.27-2.6,14.09-8.11,21.84-8.84,5.42-.52,9.83,1.29,10.65,8S338.46,507.14,332.8,509.57Z",
  transform: "translate(-25.44 -72.24)",
  fill: "url(#5cb8051f-96be-4c7d-9e37-aa3efd21256e)"
});

var _ref94 = /*#__PURE__*/React.createElement("path", {
  d: "M188.29,647.08a21.92,21.92,0,0,1,1.44,19.23c-2.43,6.09-2.7,13.68-2.45,19.25-3.15-1.82-6.28-3.68-9.39-5.55q-5.74-3.46-11.43-7c-5-3.12-10-6.32-15-9.59l-2.34-1.56-.9-.61a1.88,1.88,0,0,0-.29-.4c-1.34-1.42-9.15-12.62-13.79-21.12-.84-1.56-1.57-3-2.15-4.32l0-.07c-1-2.22-1.47-4-1.17-4.81a9.86,9.86,0,0,1,4.85-6c5.76-3,15-.23,24.14,4.18a166.93,166.93,0,0,1,22.54,13.73l.81.59.08.06c3,2.13,4.74,3.54,4.74,3.54S188.11,646.79,188.29,647.08Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#fbbebe"
});

var _ref95 = /*#__PURE__*/React.createElement("path", {
  d: "M186.77,645.75A21.92,21.92,0,0,1,188.21,665c-2.43,6.09-2.7,13.68-2.45,19.26q-4.72-2.75-9.39-5.56-5.75-3.46-11.43-7c-5-3.13-10-6.33-14.95-9.6l-2.34-1.56-.9-.61a2.17,2.17,0,0,0-.29-.4c-1.34-1.41-9.15-12.61-13.79-21.12-.84-1.56-1.57-3-2.15-4.32l0-.06c-1-2.23-1.47-4-1.17-4.82a9.89,9.89,0,0,1,4.85-6c5.76-3,15-.23,24.14,4.18a166.93,166.93,0,0,1,22.54,13.73l.81.59.08.06c3,2.13,4.74,3.54,4.74,3.54S186.59,645.46,186.77,645.75Z",
  transform: "translate(-25.44 -72.24)",
  opacity: 0.05
});

var _ref96 = /*#__PURE__*/React.createElement("path", {
  d: "M223.59,670a24.42,24.42,0,0,1-1.41,5,39.54,39.54,0,0,0-2.27,9v0a79.52,79.52,0,0,0,.08,19.67Q203.4,695,187.28,685.56c-3.15-1.82-6.28-3.68-9.39-5.55-.7-5.32-1.7-10-2.83-11.15-1.48-1.56-9.93-13.64-15.18-23.17-.68-1.2-1.27-2.36-1.82-3.46l0-.05c-.21-.44-.41-.86-.6-1.28-1.35-2.9-2.07-5.16-1.71-6.25a11.54,11.54,0,0,1,4.12-5.94c8.87-6.48,27.31,2.29,41.47,11l.35.21c2.68,1.67,5.22,3.32,7.5,4.86l1.33.9c5.86,4,9.75,7.11,9.75,7.11a21.29,21.29,0,0,1,2.31,4.78,25.34,25.34,0,0,1,.83,2.9A24.17,24.17,0,0,1,223.59,670Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#fbbebe"
});

var _ref97 = /*#__PURE__*/React.createElement("path", {
  d: "M134.19,639.73c7.27,2.54,18,5.91,23.84,6a11.29,11.29,0,0,0,1.81-.09h0c4.11-.56,16.78.34,28.41,1.39,4.66.41,9.15.84,12.86,1.22l9.32,1v-3.6c-2.59-1.78-5.6-3.76-8.82-5.76-14.21-8.78-32.88-17.75-41.82-11.22-12.59-6.08-25.37-9-29,1.82C130.37,631.9,131.9,635.48,134.19,639.73Z",
  transform: "translate(-25.44 -72.24)",
  opacity: 0.1
});

var _ref98 = /*#__PURE__*/React.createElement("path", {
  d: "M99.26,555.92c.2,5.39,2.22,19.38,16.69,33.51,18.46,18,10.59,43.88,10.59,43.88s22,8.64,31.49,8.87a11.29,11.29,0,0,0,1.81-.09c5.69-.79,28.31,1.3,41.31,2.61l9.32,1V569.18L108.53,544.42l-9.23,9.2A18,18,0,0,0,99.26,555.92Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#5c5c8e"
});

var _ref99 = /*#__PURE__*/React.createElement("path", {
  d: "M135.46,630.91",
  transform: "translate(-25.44 -72.24)",
  fill: "none"
});

var _ref100 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.1
}, /*#__PURE__*/React.createElement("path", {
  d: "M208.8,644.75l1.67.17v.82l-9.32-1c-9.33-.94-23.59-2.28-33-2.67C174.66,641.49,196.21,643.48,208.8,644.75Z",
  transform: "translate(-25.44 -72.24)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M99.3,553.67l9.23-9.2,6.16,1.49L107,553.67a18,18,0,0,0,0,2.3c.2,5.39,2.22,19.37,16.69,33.51,18.46,18,10.59,43.87,10.59,43.87s18.2,7.15,28.63,8.62a24.73,24.73,0,0,0-3,.17,11.29,11.29,0,0,1-1.81.09c-9.49-.24-31.49-8.88-31.49-8.88s7.87-25.87-10.59-43.87C101.48,575.34,99.46,561.36,99.26,556A18,18,0,0,1,99.3,553.67Z",
  transform: "translate(-25.44 -72.24)"
}));

var _ref101 = /*#__PURE__*/React.createElement("path", {
  d: "M303,501.88s30.83-21.38,33.08-2.14S303,516.28,303,516.28Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#fbbebe"
});

var _ref102 = /*#__PURE__*/React.createElement("path", {
  d: "M249.84,487.7s16.67,11,25.9,10.35c0,0,25.2,3.38,28.13,1.69s4.73,24.42,4.73,24.42l-41.41-2.93-26.56-4.05s-13.28-8.1-13.28-15.08S249.84,487.7,249.84,487.7Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#f7cddd"
});

var _ref103 = /*#__PURE__*/React.createElement("path", {
  d: "M249.84,487.7s16.67,11,25.9,10.35c0,0,25.2,3.38,28.13,1.69s4.73,24.42,4.73,24.42l-41.41-2.93-26.56-4.05s-13.28-8.1-13.28-15.08S249.84,487.7,249.84,487.7Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
});

var _ref104 = /*#__PURE__*/React.createElement("path", {
  d: "M274.28,543.34s37.49-1.55,29.09,15.91-36.8-3.74-36.8-3.74Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#fbbebe"
});

var _ref105 = /*#__PURE__*/React.createElement("path", {
  d: "M236.58,506.15s30.38-22.73,26.11-50.41-26.11,21.16-26.11,21.16Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#5c5c8e"
});

var _ref106 = /*#__PURE__*/React.createElement("path", {
  d: "M245,380.66a38.41,38.41,0,0,0,10.8,26.68A38.63,38.63,0,0,0,269,416.25a34.46,34.46,0,0,0,4.94,1.64,39,39,0,0,0,5.45,1c1.32.13,2.65.2,4,.2A37.85,37.85,0,0,0,296,416.9,38.4,38.4,0,1,0,245,380.66Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#fbbebe"
});

var _ref107 = /*#__PURE__*/React.createElement("path", {
  d: "M99.26,555.92c3.44.63,7.69,1.79,7.69,3.57,0,3,48,19.21,48,19.21s-1.8,4.19,3,11.4,43.83,48.61,43.83,48.61l-.13,1.22-.5,4.77-2.38,22.81s15-5.4,19.8-4.8c1.55.19,3.24-.8,4.79-2.24a23,23,0,0,0-3.13-7.67s-3.89-3.06-9.76-7.11V569.18L108.53,544.42l-9.23,9.2A18,18,0,0,0,99.26,555.92Z",
  transform: "translate(-25.44 -72.24)",
  opacity: 0.1
});

var _ref108 = /*#__PURE__*/React.createElement("path", {
  d: "M94.94,551.69s12,1.19,12,4.2,48,19.21,48,19.21-1.8,4.19,3,11.4,43.83,48.61,43.83,48.61l-3,28.8s15-5.4,19.8-4.8c2.15.27,4.52-1.72,6.48-4a41.88,41.88,0,0,0,4.33-6.17s-5.41-22.82,1.8-28.22-7.8-45-7.8-45-6.79-28.16-4.79-40.24a14.69,14.69,0,0,1,.58-2.37c0-.09.05-.18.09-.27,4.28-11.54,50.32-108.35,50.32-108.35a68.91,68.91,0,0,0-.58-8.21c-.09-.76-.21-1.55-.36-2.34a40.2,40.2,0,0,0-.93-4.27c-.26-.92-.54-1.8-.87-2.64-1.42-3.66-3.6-6.47-6.86-6.54,0,0-3.6-4-12-5.06-6.2-.81-15,0-27,5.06-28.2,12-34.8,12.6-34.8,12.6L172,431.66l-2.92,3.82a367.29,367.29,0,0,0-28.91,43.89c-4.72,8.48-11.4,18.37-19.41,24.31C104.55,515.69,94.94,551.69,94.94,551.69Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
});

var _ref109 = /*#__PURE__*/React.createElement("path", {
  d: "M200.12,482.3s-40.06,9.9-55.59,34.88Z",
  transform: "translate(-25.44 -72.24)",
  opacity: 0.1
});

var _ref110 = /*#__PURE__*/React.createElement("path", {
  d: "M187.74,526.18s-7.57,50.86-5.47,54.69S187.74,526.18,187.74,526.18Z",
  transform: "translate(-25.44 -72.24)",
  opacity: 0.1
});

var _ref111 = /*#__PURE__*/React.createElement("path", {
  d: "M190.45,552.29c2.92,3.82,14.75,33.31,14.75,33.31l-3.42,49.51-3,28.8s15-5.4,19.81-4.8c2.14.27,4.52-1.71,6.48-4-3.12-16.87-9.78-52.16-11-52.84-1.59-.9-9.69-29.26-10.12-37.14s-11.71-25.64-11.71-25.64S187.52,548.47,190.45,552.29Z",
  transform: "translate(-25.44 -72.24)",
  opacity: 0.1
});

var _ref112 = /*#__PURE__*/React.createElement("path", {
  d: "M201.78,503.68c.73,2.25,1.89,15.3,1.89,15.3.82,11.51,9.52,15.27,14.92,16.47a14.69,14.69,0,0,1,.58-2.37c3.6-10.19,50.41-108.62,50.41-108.62a64.63,64.63,0,0,0-1.87-14.82c-10.19-3-26.33,1.62-26.33,1.62-4.66-.61-19.87,29.64-19.87,29.64s-10.14,23.17-11.25,26.32,0,8.34-.45,10.14-5.19,3.36-5.86,5.85-.23,7.41-.68,8.31S201,501.43,201.78,503.68Z",
  transform: "translate(-25.44 -72.24)",
  opacity: 0.1
});

var _ref113 = /*#__PURE__*/React.createElement("path", {
  d: "M205.38,501.88c.74,2.25,1.89,15.3,1.89,15.3.68,9.58,6.84,13.79,12,15.63a25.3,25.3,0,0,0,7.2,1.44l7.24,6.28,33.41,24.65s12.46-23,9.08-23.15-22.87-16.5-22.87-16.5c-6-3.18-11.94-13.82-14.71-19.28a15.54,15.54,0,0,0,.36-2c1.21-10.19,26.41-49.2,26.41-49.2s9.74-11.47,13.54-32.72c.11-.48.18-1,.27-1.49a16.31,16.31,0,0,0,.2-2c.45-8.17-5.49-11.14-12.55-11.85h0a50.82,50.82,0,0,0-11,.34,79.22,79.22,0,0,0-10.8,2.12c-3-.39-10.46,12.16-15.34,21.05h0c-2.63,4.82-4.52,8.59-4.52,8.59S215,462.27,213.86,465.42s0,8.33-.45,10.14-5.19,3.36-5.85,5.85-.24,7.41-.69,8.31S204.62,499.63,205.38,501.88Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
});

var _ref114 = /*#__PURE__*/React.createElement("path", {
  d: "M166.61,450c6.34,6.52,16.68,6.54,24.94,3.23s15.27-9.35,22.94-14c5-3,10.24-5.53,15.14-8.66h0c.72-.47,1.42-.94,2.1-1.42,5.66-4,10.55-9.13,16.4-12.8a25.52,25.52,0,0,1,13.18-4.22,14.93,14.93,0,0,1,6.29,1.32,8.13,8.13,0,0,1,1,.52,27.32,27.32,0,0,1,5.3,4c1.65,1.49,3.24,3.08,5,4.46.11-.48.18-1,.27-1.49a16.31,16.31,0,0,0,.2-2c1.32.13,2.65.2,4,.2A37.85,37.85,0,0,0,296,416.9c0-.16.06-.33.09-.49,1.44-7.56,4-15.57,10.12-19.82,3.53-2.47,9.17-3.47,14.05-5.35a38.4,38.4,0,1,0-72.36,4.16c-6.2-.81-15,0-27,5.06-28.2,12-34.8,12.6-34.8,12.6L172,431.66c1.53,2.34,3.26,4.65,3.42,7.38C175.74,444.1,170.86,447.59,166.61,450Z",
  transform: "translate(-25.44 -72.24)",
  opacity: 0.1
});

var _ref115 = /*#__PURE__*/React.createElement("path", {
  d: "M306.26,393c-6.09,4.26-8.68,12.26-10.12,19.81-.45,2.36-.88,4.85-2.32,6.72-3.23,4.19-9.73,3-13.95,0s-7.54-7.56-12.25-9.69c-6.26-2.82-13.61-.76-19.46,2.91s-10.75,8.8-16.41,12.79c-5.47,3.86-11.57,6.61-17.27,10.08-7.66,4.67-14.66,10.7-22.93,14s-18.6,3.3-24.93-3.22c4.25-2.36,9.13-5.85,8.8-10.9s-6.22-8.84-5.82-14,6.49-7.22,10.86-9.76c9.15-5.32,13-17,15-27.8,1.52-8.43,2.77-17.86,9.08-23.27,4.06-3.49,9.57-4.63,13.66-8.08,3.88-3.28,6-8.25,8.48-12.82,4.07-7.63,9.41-14.71,16.48-19.27s16.06-6.32,23.82-3.25c3,1.17,5.68,3,8.62,4.27,7.3,3.16,15.67,2.74,22.91,6.06,8.91,4.1,14.7,13.16,20,21.76,4.53,7.35,13.39,20.36,10.91,29.86C326.89,388.89,312.87,388.37,306.26,393Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#7c5c5c"
});

var _ref116 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.1
}, /*#__PURE__*/React.createElement("path", {
  d: "M169.6,420.87a6.21,6.21,0,0,1,.21-1.17c1.61,2.54,3.62,5,3.81,8a6.91,6.91,0,0,1-.17,2.05C171.66,426.87,169.35,424.18,169.6,420.87Z",
  transform: "translate(-25.44 -72.24)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M189.75,441.81c8.27-3.32,15.27-9.35,22.93-14,5.7-3.47,11.8-6.22,17.27-10.08,5.66-4,10.56-9.13,16.41-12.79s13.2-5.73,19.46-2.91c4.71,2.13,8,6.64,12.25,9.69s10.72,4.24,13.95.05c1.45-1.87,1.87-4.35,2.32-6.71,1.44-7.56,4-15.56,10.12-19.82,6.62-4.62,20.63-4.1,23.17-13.85a15,15,0,0,0,.33-5.29c1.63,4.33,2.46,8.69,1.48,12.49-2.55,9.75-16.56,9.23-23.18,13.85-6.08,4.26-8.68,12.26-10.12,19.82-.45,2.36-.87,4.85-2.31,6.71-3.24,4.19-9.74,3-14-.05s-7.54-7.56-12.25-9.69c-6.26-2.82-13.61-.75-19.46,2.91s-10.75,8.8-16.41,12.79c-5.47,3.87-11.57,6.61-17.27,10.08-7.66,4.68-14.66,10.7-22.93,14s-18.6,3.29-24.93-3.23a31.11,31.11,0,0,0,4.64-3.08C177,444.81,183.9,444.15,189.75,441.81Z",
  transform: "translate(-25.44 -72.24)"
}));

var _ref117 = /*#__PURE__*/React.createElement("path", {
  d: "M841,343.64l-41-41.23a21.77,21.77,0,0,0-30.92-.21L511.62,557.48,402.76,447.77a21.71,21.71,0,0,0-30.7-.22l-41.44,41a22,22,0,0,0-.21,30.92L495.73,686.09a22,22,0,0,0,30.92.22L840.77,374.55A21.77,21.77,0,0,0,841,343.64Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#3acc6c"
});

var _ref118 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M779.22,674.25s-30.58-1.84-27,19.59a5.23,5.23,0,0,0,2.72,5.5s0-1.59,3.13-1.05a13.8,13.8,0,0,0,3.33.16,6.87,6.87,0,0,0,4.06-1.67h0s8.59-3.55,11.94-17.61c0,0,2.47-3.06,2.37-3.85l-5.16,2.21s1.77,3.72.38,6.81c0,0-.17-6.68-1.16-6.52-.2,0-2.68,1.29-2.68,1.29s3,6.48.74,11.2c0,0,.87-8-1.69-10.73l-3.63,2.12s3.54,6.7,1.14,12.16c0,0,.62-8.38-1.91-11.64l-3.29,2.56s3.33,6.6,1.3,11.14c0,0-.26-9.76-2-10.5,0,0-2.88,2.54-3.32,3.59,0,0,2.28,4.79.87,7.32,0,0-.87-6.51-1.58-6.53,0,0-2.87,4.3-3.17,7.25a15.62,15.62,0,0,1,2.47-7.67,8.66,8.66,0,0,0-4.39,2.28s.44-3,5.1-3.32c0,0,2.37-3.26,3-3.46,0,0-4.63-.39-7.44.86,0,0,2.47-2.88,8.28-1.57l3.25-2.65s-6.09-.84-8.68.08c0,0,3-2.54,9.56-.69l3.54-2.11s-5.2-1.12-8.3-.72c0,0,3.27-1.76,9.34.15l2.53-1.14s-3.81-.75-4.93-.86-1.17-.43-1.17-.43a13.23,13.23,0,0,1,7.15.8S779.31,674.59,779.22,674.25Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
}));

var _ref119 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M724.35,524.59s-15.53,26.41,5.21,32.93a5.24,5.24,0,0,0,6.14.08s-1.39-.77.48-3.27a14.32,14.32,0,0,0,1.66-2.89,7,7,0,0,0,.35-4.38h0s.73-9.27-10.27-18.63c0,0-1.61-3.6-2.35-3.87l-.38,5.6s4.11.12,6.24,2.76c0,0-6-2.88-6.34-1.93-.06.2-.07,3-.07,3s7.16.24,10.32,4.42c0,0-6.72-4.4-10.33-3.36l.24,4.2s7.58-.12,11.36,4.5c0,0-7.19-4.36-11.24-3.59l.79,4.1s7.4,0,10.51,3.89c0,0-8.81-4.19-10.26-3,0,0,1,3.72,1.68,4.59,0,0,5.31.14,6.92,2.55,0,0-6.19-2.18-6.54-1.56,0,0,2.54,4.51,5,6.12a15.65,15.65,0,0,1-5.71-5.69,8.62,8.62,0,0,0,0,5s-2.51-1.78-.63-6c0,0-1.84-3.59-1.73-4.25,0,0-2.44,3.95-2.61,7,0,0-1.44-3.51,2.36-8.1l-.88-4.1s-3.51,5.06-3.87,7.78c0,0-.91-3.81,3.73-8.83l-.28-4.11s-3.36,4.12-4.4,7.06c0,0-.09-3.71,4.36-8.25l.14-2.77s-2.4,3.06-3,4-.91.85-.91.85a13.15,13.15,0,0,1,3.95-6S724.69,524.66,724.35,524.59Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
}));

var _ref120 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M627.22,313.88s-15.52,26.42,5.21,32.93a5.22,5.22,0,0,0,6.14.08s-1.39-.77.49-3.27a14.24,14.24,0,0,0,1.65-2.89,6.93,6.93,0,0,0,.35-4.38h0s.74-9.27-10.27-18.63c0,0-1.61-3.59-2.35-3.86l-.38,5.59s4.12.12,6.24,2.76c0,0-6-2.88-6.33-1.93-.07.2-.07,3-.07,3s7.15.24,10.31,4.42c0,0-6.72-4.4-10.33-3.36l.25,4.2s7.57-.12,11.35,4.5c0,0-7.19-4.35-11.24-3.59l.79,4.1s7.4,0,10.52,3.9c0,0-8.82-4.2-10.27-3,0,0,1,3.71,1.69,4.58,0,0,5.3.14,6.91,2.55,0,0-6.19-2.18-6.53-1.56,0,0,2.53,4.52,5,6.12a15.66,15.66,0,0,1-5.72-5.68,8.68,8.68,0,0,0,0,4.94s-2.51-1.78-.63-6.05c0,0-1.84-3.59-1.73-4.25,0,0-2.44,3.95-2.61,7,0,0-1.44-3.51,2.37-8.1l-.89-4.1s-3.51,5.06-3.86,7.78c0,0-.92-3.81,3.72-8.83l-.28-4.11s-3.36,4.12-4.4,7.06c0,0-.09-3.71,4.36-8.24l.14-2.78s-2.4,3.06-3,4-.91.85-.91.85a13.22,13.22,0,0,1,4-6S627.56,314,627.22,313.88Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
}));

var _ref121 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M292.86,113.79s-57.8,42-19.54,75.27c0,0,4.33,7.88,13.06,5.89,0,0-2.26-2.94,4.09-6.54a32.57,32.57,0,0,0,6.22-4.64,16.1,16.1,0,0,0,4.83-9h0s10.22-19.14-4.59-49.4c0,0-.09-9.19-1.44-10.46l-6,11.62s8.69,4.09,10.78,11.72c0,0-10.21-11.79-11.76-10-.31.35-2.92,6.3-2.92,6.3s15.09,7.18,17.95,19.06c0,0-10.28-15.68-19-16.82l-3.39,9.21s16.31,6.81,20.09,20.21c0,0-11.32-16-20.7-18.15l-2.12,9.51s15.78,6.95,18.85,18.12c0,0-15-17.18-19.19-15.91,0,0-1.42,8.84-.67,11.37,0,0,11.22,5.25,12.42,11.9,0,0-11.21-10.42-12.53-9.42,0,0,1.22,12,5.06,17.77,0,0-6.29-8.09-6.93-17.48,0,0-4.29,5-4.53,10.61,0,0-3.72-6.15,4.27-13.53,0,0-.57-9.4.28-10.7,0,0-8.92,6.17-12.13,12.57,0,0,.19-8.84,12.6-15.11l1.92-9.59s-12.21,7.53-15.5,13c0,0,1.59-9,16.18-15.42l3.24-9.05s-11,5.69-16,11c0,0,3.27-8,17-13.57l2.87-5.8s-8,4.3-10.15,5.74-2.75,1-2.75,1a30.76,30.76,0,0,1,14.06-9.17S293.53,114.26,292.86,113.79Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
}));

var _ref122 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M236.71,252.38s-74.77-31.44-84.57,25.25c0,0-5.11,8.84,2,16.14,0,0,1.53-3.92,8.76.13a37.17,37.17,0,0,0,8.16,3.32,18.36,18.36,0,0,0,11.62-.62h0s24.58-1.33,45.27-33.5c0,0,8.86-5.48,9.31-7.54l-14.83,1s1.14,10.85-5,17.36c0,0,5.45-16.84,2.83-17.31-.53-.1-7.83.86-7.83.86s1.89,18.87-8,28.63c0,0,9.18-19.19,5.18-28.29l-10.93,2.11s3,19.85-7.82,31.39c0,0,8.89-20.4,5.46-30.76l-10.48,3.52s2.53,19.41-6.52,29c0,0,7.9-24.61,4.18-28,0,0-9.42,3.82-11.44,6,0,0,1.5,14-4.26,19.05,0,0,3.54-17,1.79-17.7,0,0-10.95,8.24-14.29,15.35,0,0,4.17-10.86,12.91-17,0,0-7.34-1.25-13,1.83,0,0,3.79-7.21,15.65-3.79,0,0,8.79-6.09,10.55-6,0,0-11.22-5-19.33-4.38,0,0,8.69-5,22.07,3.35L194.58,258s-14.49-7.43-21.76-7.4c0,0,9.66-3.74,24.48,6.66L208,255.05S196,247.7,187.9,246c0,0,9.71-1.54,23.18,8.55l7.32-.61s-8.86-5.22-11.54-6.49-2.56-2.09-2.56-2.09a34.9,34.9,0,0,1,17.17,8.26S236.64,253.31,236.71,252.38Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
}));

var _ref123 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M191.94,173s-26.51-61.27-64.62-33.17c0,0-8.07,2.34-8,10.7,0,0,3.14-1.46,5.12,5.07a31.06,31.06,0,0,0,3,6.61,15.06,15.06,0,0,0,7.26,6.25h0s15.36,13.22,46,5.89c0,0,8.39,1.79,9.83.83l-9.37-7.87s-5.5,7.1-12.88,7.44c0,0,12.83-6.9,11.54-8.67-.26-.36-5.14-3.94-5.14-3.94s-9.63,12.28-21,12.47c0,0,16.39-6.18,19.19-13.85l-7.7-5S155.5,169.29,142.51,170c0,0,16.9-7.05,20.77-15.17L155.05,151s-9.56,13-20.37,13.49c0,0,18.71-10.12,18.42-14.25,0,0-7.77-3.1-10.23-2.92,0,0-7.07,9.15-13.38,8.89,0,0,11.79-8.09,11.14-9.5,0,0-11.2-1.34-17.23,1,0,0,8.66-4.08,17.35-2.74,0,0-3.65-4.93-8.75-6.3,0,0,6.37-2.13,11.46,6.65,0,0,8.69,1.4,9.7,2.44,0,0-3.8-9.39-9-13.62,0,0,8,2,11.21,14.57l8.35,3.71s-4.37-12.68-8.71-16.79c0,0,7.87,3.28,10.75,17.9l7.59,4.79s-2.94-11.2-6.77-16.83c0,0,6.64,4.62,8.9,18.29l4.7,3.8s-2.3-8.14-3.17-10.42-.32-2.7-.32-2.7a28.75,28.75,0,0,1,5.49,14.68S191.38,173.53,191.94,173Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
}));

var _ref124 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M708.62,204.88s-6.25-30-26-20.89a5.22,5.22,0,0,0-4.6,4.07s1.55-.37,1.84,2.75a14.34,14.34,0,0,0,.71,3.25,7,7,0,0,0,2.69,3.48h0s5.68,7.36,20.11,6.9c0,0,3.61,1.58,4.35,1.28l-3.49-4.4s-3.13,2.68-6.47,2.15c0,0,6.4-1.91,6-2.83-.09-.19-1.95-2.25-1.95-2.25s-5.46,4.63-10.61,3.66c0,0,7.93-1.26,9.91-4.45l-3-2.95s-5.54,5.18-11.44,4.29c0,0,8.25-1.6,10.74-4.89l-3.34-2.5s-5.5,4.94-10.41,4.17c0,0,9.35-2.82,9.6-4.7,0,0-3.2-2.11-4.33-2.26,0,0-4,3.46-6.83,2.76,0,0,6-2.54,5.89-3.24,0,0-4.91-1.64-7.84-1.15a15.71,15.71,0,0,1,8.05.37,8.58,8.58,0,0,0-3.35-3.64s3.06-.37,4.54,4c0,0,3.77,1.43,4.13,2,0,0-.84-4.57-2.78-7,0,0,3.42,1.63,3.69,7.59l3.41,2.44s-.79-6.1-2.36-8.36c0,0,3.23,2.21,3.17,9l3,2.86s-.28-5.31-1.48-8.19c0,0,2.55,2.69,2.3,9l1.76,2.15s-.27-3.87-.45-5,.1-1.25.1-1.25a13.22,13.22,0,0,1,1.11,7.12S708.32,205.06,708.62,204.88Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
}));

var _ref125 = /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("path", {
  d: "M601,761s-6.24-30-26-20.89a5.23,5.23,0,0,0-4.61,4.07s1.55-.37,1.84,2.75a13.81,13.81,0,0,0,.72,3.25,7,7,0,0,0,2.68,3.48h0s5.68,7.36,20.12,6.9c0,0,3.61,1.58,4.34,1.28l-3.48-4.4s-3.13,2.68-6.48,2.15c0,0,6.4-1.91,6-2.83-.08-.19-1.95-2.25-1.95-2.25s-5.46,4.63-10.61,3.66c0,0,7.94-1.26,9.91-4.45l-3-3S585,755.92,579.08,755c0,0,8.25-1.6,10.74-4.89l-3.34-2.5s-5.49,4.94-10.4,4.17c0,0,9.35-2.81,9.6-4.7,0,0-3.21-2.11-4.33-2.26,0,0-4,3.46-6.84,2.76,0,0,6-2.54,5.89-3.24,0,0-4.91-1.64-7.84-1.15a15.74,15.74,0,0,1,8.06.37,8.65,8.65,0,0,0-3.35-3.64s3.05-.37,4.53,4c0,0,3.78,1.43,4.14,2,0,0-.84-4.57-2.78-7,0,0,3.42,1.63,3.68,7.59l3.42,2.44s-.8-6.1-2.37-8.36c0,0,3.24,2.21,3.18,9l3,2.86s-.28-5.31-1.49-8.19c0,0,2.56,2.69,2.31,9l1.76,2.15s-.28-3.87-.46-5,.1-1.24.1-1.24a13.17,13.17,0,0,1,1.11,7.11S600.72,761.15,601,761Z",
  transform: "translate(-25.44 -72.24)",
  fill: "#ff8910"
}));

const SvgFinish = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "875ecf71-6e24-4878-8942-f452de3ecca7",
    "data-name": "Layer 1",
    width: 1149.12,
    height: 755.51,
    viewBox: "0 0 1149.12 755.51",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64, _ref65, _ref66, _ref67, _ref68, _ref69, _ref70, _ref71, _ref72, _ref73, _ref74, _ref75, _ref76, _ref77, _ref78, _ref79, _ref80, _ref81, _ref82, _ref83, _ref84, _ref85, _ref86, _ref87, _ref88, _ref89, _ref90, _ref91, _ref92, _ref93, _ref94, _ref95, _ref96, _ref97, _ref98, _ref99, _ref100, _ref101, _ref102, _ref103, _ref104, _ref105, _ref106, _ref107, _ref108, _ref109, _ref110, _ref111, _ref112, _ref113, _ref114, _ref115, _ref116, _ref117, _ref118, _ref119, _ref120, _ref121, _ref122, _ref123, _ref124, _ref125);
};

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFinish, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/finish.f7ff03e1.svg";
export { ForwardRef as ReactComponent };